const INITIAL_STATE = {
    notificacoes: {}
}

export default function Notificacoes(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'NOTIFICACOES_FETCHED' :
            return { ...state, notificacoes: action.payload}
        
        default :
            return state
    }
}